<script lang="ts">
    import { onMount } from "svelte"
    import { tick } from "svelte"
    import { _ } from "svelte-i18n"
    import { langField } from "../../../../i18n"
    let { product }: { product: Product } = $props()
    const hasAnyInformations = !!(
        product.filter_params.external_dimension_width ||
        product.filter_params.external_dimension_height ||
        product.filter_params.external_dimension_depth ||
        product.filter_params.weight ||
        langField(product.scope_of_delivery) ||
        (product.downloads?.de && product.downloads.de.length > 0)
    )
    const sectionIds = [
        "product-description",
        "product-highlights",
        hasAnyInformations ? "product-details" : "",
        "customer-reviews",
    ].filter(Boolean)

    let availableSections: { id: string; label: string }[] = $state([])

    function checkSections() {
        availableSections = sectionIds
            .map((id) => {
                const element = document.getElementById(id)
                return element ? { id, label: getLabel(id) } : null
            })
            .filter(Boolean) as { id: string; label: string }[]
    }

    function getLabel(id: string): string {
        switch (id) {
            case "product-description":
                return $_("product.description")
            case "product-details":
                return product?.downloads?.de && product.downloads.de.length > 0
                    ? $_("product.product-details-and-downloads")
                    : $_("product.product-details")
            case "product-highlights":
                return $_("product.highlights")
            case "customer-reviews":
                return $_("ratings.customer-reviews")
            case "individual-product-details":
                return $_("product.individual-renz-highlights")
            default:
                return "Abschnitt"
        }
    }

    function scrollToSection(id: string) {
        const element = document.getElementById(id)
        if (element) {
            const elementPosition = element.getBoundingClientRect().top
            const offset = window.innerHeight * 0.1
            window.scrollTo({
                top: window.scrollY + elementPosition - offset,
                behavior: "smooth",
            })
        }
    }

    // Überwachung, ob die Abschnitte geladen werden
    let observer: MutationObserver
    onMount(() => {
        checkSections() // Initiales Prüfen
        observer = new MutationObserver(() => {
            tick().then(() => checkSections())
        })
        observer.observe(document.body, { childList: true, subtree: true })
        return () => observer.disconnect()
    })
</script>

<ul class="section-list">
    {#each availableSections as section}
        <li class="section-item">
            <button onclick={() => scrollToSection(section.id)} class="button transparent">
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                        <path
                            d="M20.538 25.962L19.4775 24.882L25.6095 18.75H7.5V17.25H25.6095L19.4775 11.118L20.538 10.038L28.5 18L20.538 25.962Z"
                            fill="#464646"
                        >
                        </path>
                    </svg>
                </span>
                <span class="section-label">
                    {section.label}
                </span>
            </button>
        </li>
    {/each}
</ul>

<style>
    ul {
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        flex-direction: column;
        margin-bottom: 1.2rem;
        li {
            display: flex;
            align-items: center;
            border-top: 1px solid var(--grey-400);
            button {
                width: 100%;
                gap: 1.2rem;
                padding: 0.6rem 0px !important;
                display: flex;
                justify-content: flex-start;
                span {
                    display: flex;
                    align-items: center;
                }
                .section-label {
                    padding: 0px;
                    margin: 0px;
                    color: var(--grey-400);
                    font-size: 1.17em;
                    font-weight: bold;
                }
            }
        }
    }
</style>
